
// frontend/src/utils/validation.js
// Form validation utilities

// Email validation
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Password validation - at least 8 chars, 1 uppercase, 1 lowercase, 1 number
export const validatePassword = (password) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

// Calculate password strength (0-4)
export const getPasswordStrength = (password) => {
  let strength = 0;
  if (password.length >= 8) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[0-9]/.test(password)) strength++;
  if (/[^A-Za-z0-9]/.test(password)) strength++;
  return strength;
};

// Get strength label
export const getPasswordStrengthLabel = (strength) => {
  if (strength === 0) return '';
  if (strength === 1) return 'Weak';
  if (strength === 2) return 'Fair';
  if (strength === 3) return 'Good';
  return 'Strong';
};

// Get strength color
export const getPasswordStrengthColor = (strength) => {
  if (strength === 0) return '';
  if (strength === 1) return '#ef4444';      // Red
  if (strength === 2) return '#f59e0b';      // Orange
  if (strength === 3) return '#06b6d4';      // Cyan
  return '#10b981';                          // Green
};

// Validate Sign In form
export const validateSignInForm = (email, password) => {
  const errors = {};

  if (!email.trim()) {
    errors.email = 'Email is required';
  } else if (!validateEmail(email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (!password) {
    errors.password = 'Password is required';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validate Sign Up form
export const validateSignUpForm = (firstName, email, password, confirmPassword, acceptTerms) => {
  const errors = {};

  // First name validation
  if (!firstName.trim()) {
    errors.firstName = 'Full name is required';
  } else if (firstName.trim().length < 2) {
    errors.firstName = 'Name must be at least 2 characters';
  }

  // Email validation
  if (!email.trim()) {
    errors.email = 'Email is required';
  } else if (!validateEmail(email)) {
    errors.email = 'Please enter a valid email address';
  }

  // Password validation
  if (!password) {
    errors.password = 'Password is required';
  } else if (!validatePassword(password)) {
    errors.password = 'Password must be at least 8 characters with uppercase, lowercase, and number';
  }

  // Confirm password validation
  if (!confirmPassword) {
    errors.confirmPassword = 'Please confirm your password';
  } else if (password !== confirmPassword) {
    errors.confirmPassword = 'Passwords do not match';
  }

  // Terms validation
  if (!acceptTerms) {
    errors.acceptTerms = 'You must accept the terms and conditions';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validate email format
export const isValidEmail = (email) => {
  return validateEmail(email);
};

// Validate password strength
export const isStrongPassword = (password) => {
  return validatePassword(password);
};

// Get password requirements message
export const getPasswordRequirements = () => {
  return 'Password must contain:\n• At least 8 characters\n• At least 1 uppercase letter (A-Z)\n• At least 1 lowercase letter (a-z)\n• At least 1 number (0-9)';
};

export default {
  validateEmail,
  validatePassword,
  getPasswordStrength,
  getPasswordStrengthLabel,
  getPasswordStrengthColor,
  validateSignInForm,
  validateSignUpForm,
  isValidEmail,
  isStrongPassword,
  getPasswordRequirements
};